export const MOBILE_BIG_TEASER_WIDTH = 790
export const MOBILE_BIG_TEASER_HEIGHT = 527

export const DESKTOP_MID_TEASER_WIDTH = 668
export const DESKTOP_MID_TEASER_HEIGHT = 445

export const LIST_TEASER_WIDTH = 338
export const LIST_TEASER_HEIGHT = 255
